export default "__VITE_ASSET__CyGltJQA__"